import React, { useEffect, useState, useContext } from "react";
import useMediaQuery from '@mui/material/useMediaQuery';

export const Flybridge = (props) => {

    const [sectionMarginTop, setSectionMarginTop] = useState('');
    const notMobile = useMediaQuery('(min-width:992px)');

    useEffect(() => {
        if (notMobile) {
        let rowPaddingFlybridge = document.querySelector('.box-flybridge').getBoundingClientRect().height;
        setSectionMarginTop(rowPaddingFlybridge + "px");
        }
    }, [notMobile]);


    return (
        <>
            {props.cultureCode === "en-us" &&
                <div className="container-fluid bkg-flybridge">
                    <div className="container py-5">
                        <div className="row justify-content-center">
                            <div className="col-md-10 text-center pt-5" data-aos="zoom-in">
                                <h2 className="text-uppercase mb-3 text-white">Feel amazing from above</h2>
                                <img src="images/Infynito80/flybridge/main.jpg" alt="" className="w-100" />
                            </div>
                            <div className="col-lg-6 position-relative">
                                <div className="box box-flybridge">
                                    <p><strong>Open version</strong>: The aft area of the sun deck is the perfect place to sunbathing. An al fresco dining area for 8 people is protected by a hardtop and served by the outdoor galley, integrated into the GRP structure on each side.</p>
                                    <p><strong>Semi enclosed version</strong>: The semi-enclosed flybridge is available as an option with wrap-around glass panels along the hard top section.</p>
                                </div>
                            </div>
                            <div className="col-lg-6 position-relative" data-aos="fade-up" data-aos-duration="1500">
                                <img src="images/Infynito80/pin.svg" alt="" className="pin pin-flybridge pin-animation" />
                                <img src="images/Infynito80/sun-deck.png" alt="" className="sundeck-flyblidge w-100" />
                            </div>
                        </div>
                        <div className="row pb-lg-5" style={{ marginTop: sectionMarginTop }}></div>
                    </div>

                    <div className="container py-5">
                        <div className="row py-5" data-aos="zoom-in">
                            <div className="col-md-5">
                                <p className="versus-text text-center">INFYNITO 80 <strong>Exterior Space Protected</strong> by Hard Top & Superstructure</p>
                                <p className="percentage">62%</p>
                            </div>
                            <div className="col-md-2">
                                <div className="valign">
                                    <div className="align-middle d-table-cell">
                                        <div className="d-table mx-auto">
                                            <p className="versus">VS</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-5">
                                <p className="versus-text text-center">75-85ft Semi-Disp. Players <strong>Exterior Space Protected</strong> by Hard Top & Superstructure</p>
                                <p className="percentage">37%</p>
                            </div>
                        </div>
                    </div>

                    <div className="container">
                        <div className="row">
                            <div className="col text-center">
                                <h3 className="title-gallery">Gallery exteriors</h3>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {props.cultureCode === "it-it" &&
                <div className="container-fluid bkg-flybridge">
                    <div className="container py-5">
                        <div className="row justify-content-center">
                            <div className="col-md-10 text-center pt-5" data-aos="zoom-in">
                                <h2 className="text-uppercase mb-3 text-white">Goditi il panorama</h2>
                                <img src="images/Infynito80/flybridge/main.jpg" alt="" className="w-100" />
                            </div>
                            <div className="col-lg-6 position-relative">
                                <div className="box box-flybridge">
                                    <p><strong>Versione aperta</strong>: l'area di poppa del flybridge è perfetta per prendere il sole, mentre a centro barca, si trova un'area pranzo per 8 persone, protetta da un hard top. Mobili wetbar equipaggiati con frigoriferi e grill sono integrati nelle murate laterali.</p>
                                    <p><strong>Versione semi-enclosed</strong>: Se preferisci un'opzione più riparata, il flybridge semi-enclosed è dotato di pannelli di vetro che circondano la sezione dell'hard top.</p>
                                </div>
                            </div>
                            <div className="col-lg-6 position-relative" data-aos="fade-up" data-aos-duration="1500">
                                <img src="images/Infynito80/pin.svg" alt="" className="pin pin-flybridge pin-animation" />
                                <img src="images/Infynito80/sun-deck.png" alt="" className="sundeck-flyblidge w-100" />
                            </div>
                        </div>
                        <div className="row pb-lg-5" style={{ marginTop: sectionMarginTop }}></div>
                    </div>

                    <div className="container py-5">
                        <div className="row py-5" data-aos="zoom-in">
                            <div className="col-md-5">
                                <p className="versus-text text-center"><strong>Spazi esterni protetti</strong> da Hard Top e sovrastruttura a bordo di INFYNITO 80</p>
                                <p className="percentage">62%</p>
                            </div>
                            <div className="col-md-2">
                                <div className="valign">
                                    <div className="align-middle d-table-cell">
                                        <div className="d-table mx-auto">
                                            <p className="versus">VS</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-5">
                                <p className="versus-text text-center"><strong>Spazi esterni protetti</strong> da Hard Top e sovrastruttura a bordo dei principali competitors semi-dislocanti tra 75-85 ft</p>
                                <p className="percentage">37%</p>
                            </div>
                        </div>
                    </div>

                    <div className="container">
                        <div className="row">
                            <div className="col text-center">
                                <h3 className="title-gallery">Gallery esterni</h3>
                            </div>
                        </div>
                    </div>
                </div>
            }


        </>
    );




};

export default Flybridge;